var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.busy,
          expression: "busy",
        },
      ],
      staticClass: "align-self-stretch flex-fill d-flex",
    },
    [
      _vm.hasError
        ? _c("placeholder", {
            staticClass: "text-danger",
            attrs: { message: _vm.items },
          })
        : _vm.messagesNotGenerated
        ? _vm._t("not-generated")
        : _c(
            "div",
            {
              staticClass:
                "px-2 pt-2 align-self-stretch flex-fill d-flex flex-column",
            },
            [
              _c(
                "div",
                { staticClass: "d-flex mb-2 search-bar" },
                [
                  _c("input-debounced", {
                    staticClass: "search-bar-input",
                    attrs: {
                      clearable: true,
                      autofocus: true,
                      placeholder: "Search",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-purple ml-1",
                        on: { click: _vm.refresh },
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-sync",
                          class: { "fa-spin": _vm.busy },
                        }),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasNoItems
                ? _c("placeholder", {
                    staticClass: "text-secondary",
                    attrs: { message: "No Items" },
                  })
                : _c(
                    "div",
                    { staticClass: "align-self-stretch flex-fill items" },
                    _vm._l(_vm.items, function (item, index) {
                      return _c("list-item", {
                        key: _vm.getItemKey(index),
                        attrs: {
                          item: item,
                          "is-selected": _vm.isSelected(item),
                        },
                        on: { select: _vm.onSelect, edit: _vm.onEdit },
                      })
                    }),
                    1
                  ),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }